import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { theme } from "../theme";
import { NAV_ITEMS, PAGE_ACCESS, ROLE_COLORS, canAccess } from "../auth";

const SHELL_HEADER_HEIGHT = 88;

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const user     = JSON.parse(sessionStorage.getItem("nexgen_user") || "{}");
  const role     = user.role || "viewer";

  // Filter nav: guests and viewers never see User Management link at all
  const visibleItems = NAV_ITEMS.filter(item => {
    // Hide User Management entirely from non-owners
    if (item.path === "/users" && !["hassaan","admin"].includes(role)) return false;
    return true;
  });

  const handleLogout = () => {
    sessionStorage.removeItem("nexgen_user");
    navigate("/login");
  };

  const roleColor = ROLE_COLORS[role] || theme.colors.textMuted;

  const shellSurface = theme.colors.sidebar || theme.colors.bg;

  return (
    <div style={{ width: 240, minHeight: "100vh", background: shellSurface, display: "flex", flexDirection: "column", position: "relative", flexShrink: 0, zIndex: 10 }}>
      {/* Logo */}
      <div style={{ height: SHELL_HEADER_HEIGHT, padding: "14px 20px 12px", flexShrink: 0, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", textAlign: "center" }}>
        <div style={{ fontFamily: theme.fonts.display, fontSize: 29, fontWeight: 900, letterSpacing: 2.35, lineHeight: 0.95 }}>
          <span style={{ color: theme.colors.accent }}>NEX</span>
          <span style={{ color: theme.colors.brandText }}>GEN</span>
        </div>
        <div style={{ fontFamily: theme.fonts.mono, fontSize: 9, marginTop: 7, letterSpacing: 1.05 }}>
          <span style={{ color: theme.colors.brandText }}>by Hassaan </span>
          <span style={{ color: theme.colors.accent }}>Alrifai</span>
        </div>
        <div style={{ width: 132, height: 2, background: `linear-gradient(90deg, transparent 0%, ${theme.colors.accent}CC 18%, ${theme.colors.accent} 50%, ${theme.colors.accent}CC 82%, transparent 100%)`, marginTop: 10 }} />
      </div>

      {/* Nav */}
      <nav style={{ flex: 1, padding: "16px 12px" }}>
        {visibleItems.map(item => {
          const active     = location.pathname === item.path;
          const accessible = canAccess(role, item.path);
          return (
            <div key={item.path}
              onClick={() => accessible && navigate(item.path)}
              title={!accessible ? "Access restricted for your role" : ""}
              style={{ padding: "11px 14px", marginBottom: 4, borderRadius: 8, cursor: accessible ? "pointer" : "not-allowed", background: active ? theme.colors.accentGlow : "transparent", borderLeft: active ? `3px solid ${theme.colors.accent}` : "3px solid transparent", opacity: accessible ? 1 : 0.35, transition: "all 0.2s" }}
              onMouseEnter={e => { if (!active && accessible) e.currentTarget.style.background = theme.colors.rowAltStrong; }}
              onMouseLeave={e => { if (!active) e.currentTarget.style.background = "transparent"; }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontSize: 17, color: active ? theme.colors.accent : theme.colors.textSecondary }}>{item.icon}</span>
                <div>
                  <div style={{ fontFamily: theme.fonts.body, fontWeight: 600, fontSize: 13, color: active ? theme.colors.accent : theme.colors.textPrimary, letterSpacing: 0.5 }}>{item.label}</div>
                  <div style={{ fontSize: 10, color: theme.colors.textMuted, fontFamily: theme.fonts.mono }}>{item.desc}</div>
                </div>
                {!accessible && <span style={{ marginLeft: "auto", fontSize: 9, color: theme.colors.textMuted }}>🔒</span>}
              </div>
            </div>
          );
        })}
      </nav>

      {/* Role indicator */}
      <div style={{ margin: "0 12px 8px", padding: "8px 12px", background: `${roleColor}11`, border: `1px solid ${roleColor}33`, borderRadius: 8 }}>
        <div style={{ fontFamily: theme.fonts.mono, fontSize: 9, color: theme.colors.textMuted, letterSpacing: 1, marginBottom: 2 }}>SESSION ROLE</div>
        <div style={{ fontFamily: theme.fonts.display, fontSize: 11, fontWeight: 700, color: roleColor, letterSpacing: 2, textTransform: "uppercase" }}>{role}</div>
      </div>

      {/* User + Logout */}
      <div style={{ padding: "12px 20px 20px", borderTop: `1px solid ${theme.colors.cardBorder}` }}>
        <div style={{ fontSize: 11, color: theme.colors.textMuted, fontFamily: theme.fonts.mono, marginBottom: 3, letterSpacing: 1 }}>LOGGED IN AS</div>
        <div style={{ fontSize: 14, color: theme.colors.textSecondary, fontFamily: theme.fonts.body, fontWeight: 700, marginBottom: 12 }}>{user.username || "User"}</div>
        <button onClick={handleLogout} style={{ width: "100%", padding: "8px", background: "rgba(255,61,87,0.1)", border: `1px solid rgba(255,61,87,0.3)`, borderRadius: 6, color: theme.colors.danger, fontFamily: theme.fonts.body, fontWeight: 600, fontSize: 12, cursor: "pointer", letterSpacing: 1 }}>
          LOGOUT
        </button>
      </div>
    </div>
  );
}
